import { jsx as a } from "react/jsx-runtime";
import { forwardRef as l } from "react";
import o from "./Tooltip.module.css.js";
import { Popover as f } from "../Popover/Popover.js";
const c = l(
  ({ children: r, show: t = !0, tooltip: e, delay: p = !0, placement: i = "top", disableOpenOnFocus: m, ...n }, s) => /* @__PURE__ */ a(
    f,
    {
      ref: s,
      ...n,
      open: t ? void 0 : !1,
      content: e,
      delay: p,
      placement: i,
      classNames: { content: o.content, arrow: o.arrow },
      triggerEvent: "hover",
      role: "tooltip",
      disableOpenOnFocus: m,
      withArrow: !0,
      children: r
    }
  )
);
c.displayName = "Tooltip";
export {
  c as Tooltip
};
//# sourceMappingURL=Tooltip.js.map
